module.exports = __webpack_public_path__ + "static/media/email-light.5f4a112c.svg";